import { render, staticRenderFns } from "./BrandRegistration.vue?vue&type=template&id=3b2a4c65"
import script from "./BrandRegistration.vue?vue&type=script&lang=js"
export * from "./BrandRegistration.vue?vue&type=script&lang=js"
import style0 from "./BrandRegistration.vue?vue&type=style&index=0&id=3b2a4c65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports